import {useCallback} from 'react'
import {connect} from 'react-redux'
import {createResource, updateResource} from 'redux-json-api'
import {Map, List} from 'immutable'
import PropTypes from 'prop-types'

import ItemPermissionsStatus from './ItemPermissionsStatus'
import QuarterbackRequestItemPermissionsModal from '../quarterback/QuarterbackRequestItemPermissionsModal'
import FirmUserRequestItemPermissionsModal from '../firm_user/FirmUserRequestItemPermissionsModal'

import {isFuneralHome} from '../../../lib/firmTools'

import {
  requestedItemPermissions,
  hasPendingRequestPermissionsInvite
} from '../../../../../lib/itemPermissionTools'

const BaseItemPermissionsContainer = props => {
  const {
    userConfig,
    requestItemPermissionsInvite,
    firm,
    firmConfig,
    firmUserConfig,
    ownership,
    allUsersDeceased,
    defaultRequestItemPermissionIds,
    inviteType,
    everplanSummary
  } = props

  const sendRequest = useCallback(checkedItemIds => {
    const attributes = {
      'invited-by-id': userConfig.get('id'),
      'everplan-id': everplanSummary.get('id'),
      'item-permissions': requestedItemPermissions({itemIds: checkedItemIds, permissionType: 'edit'}),
      status: 'pending'
    }

    if (requestItemPermissionsInvite.isEmpty()) {
      props.createResource({
        type: inviteType,
        attributes
      })
    } else {
      props.updateResource({
        type: inviteType,
        id: requestItemPermissionsInvite.get('id'),
        attributes
      })
    }
  }, [userConfig, everplanSummary, requestItemPermissionsInvite, inviteType, createResource, updateResource])

  const hasEditPermissions = !ownership.get('edit-item-ids', List()).isEmpty()
  const showLink = !isFuneralHome(firm) &&
    firmConfig.get('write-access') &&
    !hasPendingRequestPermissionsInvite(requestItemPermissionsInvite) &&
    !allUsersDeceased

  const sharedProps = {
    firmUserConfig,
    onConfirm: sendRequest,
    confirmationText: 'Send Request',
    itemPermissionIds: defaultRequestItemPermissionIds,
    requireItemPermissionSelection: true,
    ownership,
    updateResource: props.updateResource
  }

  const isQuarterback = userConfig.get('quarterback')

  return (
    <div className='item-permissions-container' data-testid={`${isQuarterback ? 'quarterback' : 'firm-user'}-item-permissions-container`}>
      <ItemPermissionsStatus
        allUsersDeceased={allUsersDeceased}
        hasPendingRequestItemPermissionsInvite={hasPendingRequestPermissionsInvite(requestItemPermissionsInvite)}
        writeAccess={firmConfig.get('write-access')}
        hasEditPermissions={hasEditPermissions}
      />

      {
        showLink && (
          isQuarterback ?
            <QuarterbackRequestItemPermissionsModal {...sharedProps} /> :
            <FirmUserRequestItemPermissionsModal {...sharedProps} />
        )
      }
    </div>
  )
}

BaseItemPermissionsContainer.propTypes = {
  firmUserConfig: PropTypes.instanceOf(Map).isRequired,
  userConfig: PropTypes.instanceOf(Map).isRequired,
  requestItemPermissionsInvite: PropTypes.instanceOf(Map).isRequired,
  firm: PropTypes.instanceOf(Map).isRequired,
  firmConfig: PropTypes.instanceOf(Map).isRequired,
  ownership: PropTypes.instanceOf(Map).isRequired,
  allUsersDeceased: PropTypes.bool.isRequired,
  defaultRequestItemPermissionIds: PropTypes.array.isRequired,
  inviteType: PropTypes.string.isRequired,
  createResource: PropTypes.func.isRequired,
  updateResource: PropTypes.func.isRequired,
  everplanSummary: PropTypes.instanceOf(Map).isRequired
}

export default connect(null, {createResource, updateResource})(BaseItemPermissionsContainer)
